import { render, staticRenderFns } from "./banksList.vue?vue&type=template&id=0fc839e0&scoped=true&"
import script from "./banksList.vue?vue&type=script&lang=js&"
export * from "./banksList.vue?vue&type=script&lang=js&"
import style0 from "./banksList.vue?vue&type=style&index=0&id=0fc839e0&lang=scss&scoped=true&"
import style1 from "./banksList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc839e0",
  null
  
)

export default component.exports